import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigDecimal: { input: any; output: any }
  BigInt: { input: any; output: any }
  Bytes: { input: any; output: any }
  Int8: { input: any; output: any }
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input']
}

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>
  number?: InputMaybe<Scalars['Int']['input']>
  number_gte?: InputMaybe<Scalars['Int']['input']>
}

export type CreateGame = {
  __typename?: 'CreateGame'
  affiliatePercent: Scalars['BigInt']['output']
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  id: Scalars['ID']['output']
  idGame: Scalars['BigInt']['output']
  jackpotPercent: Scalars['BigInt']['output']
  jackpotTerm: Scalars['BigInt']['output']
  jackpotValue: Scalars['BigInt']['output']
  megaGameContract: MegaGameContract
  newGameContract: Scalars['Bytes']['output']
  orders: Array<Order>
  ownerFee: Scalars['BigInt']['output']
  ownerPercent: Scalars['BigInt']['output']
  percents?: Maybe<Array<Scalars['BigInt']['output']>>
  price: Scalars['BigInt']['output']
  startPrice: Scalars['BigInt']['output']
  title: Scalars['String']['output']
  totalPayAmount: Scalars['BigInt']['output']
  totalQuantity: Scalars['BigInt']['output']
  totalTransactions: Scalars['BigInt']['output']
  values?: Maybe<Array<Scalars['BigInt']['output']>>
}

export type CreateGameOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Order_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<Order_Filter>
}

export type CreateGame_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  affiliatePercent?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_gt?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_gte?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  affiliatePercent_lt?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_lte?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_not?: InputMaybe<Scalars['BigInt']['input']>
  affiliatePercent_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  and?: InputMaybe<Array<InputMaybe<CreateGame_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  idGame?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  idGame_lt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_lte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  jackpotPercent?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_gt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_gte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  jackpotPercent_lt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_lte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_not?: InputMaybe<Scalars['BigInt']['input']>
  jackpotPercent_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  jackpotTerm?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_gt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_gte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  jackpotTerm_lt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_lte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_not?: InputMaybe<Scalars['BigInt']['input']>
  jackpotTerm_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  jackpotValue?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_gt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_gte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  jackpotValue_lt?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_lte?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_not?: InputMaybe<Scalars['BigInt']['input']>
  jackpotValue_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  megaGameContract?: InputMaybe<Scalars['String']['input']>
  megaGameContract_?: InputMaybe<MegaGameContract_Filter>
  megaGameContract_contains?: InputMaybe<Scalars['String']['input']>
  megaGameContract_contains_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_ends_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_gt?: InputMaybe<Scalars['String']['input']>
  megaGameContract_gte?: InputMaybe<Scalars['String']['input']>
  megaGameContract_in?: InputMaybe<Array<Scalars['String']['input']>>
  megaGameContract_lt?: InputMaybe<Scalars['String']['input']>
  megaGameContract_lte?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_contains?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_ends_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  megaGameContract_not_starts_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_starts_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  newGameContract?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_contains?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_gt?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_gte?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  newGameContract_lt?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_lte?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_not?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  newGameContract_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  or?: InputMaybe<Array<InputMaybe<CreateGame_Filter>>>
  orders_?: InputMaybe<Order_Filter>
  ownerFee?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  ownerFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  ownerPercent?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_gt?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_gte?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  ownerPercent_lt?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_lte?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_not?: InputMaybe<Scalars['BigInt']['input']>
  ownerPercent_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents_not?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
  percents_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>
  price?: InputMaybe<Scalars['BigInt']['input']>
  price_gt?: InputMaybe<Scalars['BigInt']['input']>
  price_gte?: InputMaybe<Scalars['BigInt']['input']>
  price_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  price_lt?: InputMaybe<Scalars['BigInt']['input']>
  price_lte?: InputMaybe<Scalars['BigInt']['input']>
  price_not?: InputMaybe<Scalars['BigInt']['input']>
  price_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  startPrice?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_gt?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_gte?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  startPrice_lt?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_lte?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_not?: InputMaybe<Scalars['BigInt']['input']>
  startPrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
  title_contains?: InputMaybe<Scalars['String']['input']>
  title_contains_nocase?: InputMaybe<Scalars['String']['input']>
  title_ends_with?: InputMaybe<Scalars['String']['input']>
  title_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  title_gt?: InputMaybe<Scalars['String']['input']>
  title_gte?: InputMaybe<Scalars['String']['input']>
  title_in?: InputMaybe<Array<Scalars['String']['input']>>
  title_lt?: InputMaybe<Scalars['String']['input']>
  title_lte?: InputMaybe<Scalars['String']['input']>
  title_not?: InputMaybe<Scalars['String']['input']>
  title_not_contains?: InputMaybe<Scalars['String']['input']>
  title_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>
  title_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>
  title_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  title_starts_with?: InputMaybe<Scalars['String']['input']>
  title_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  totalPayAmount?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalPayAmount_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_not?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalQuantity?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalQuantity_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_not?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

export enum CreateGame_OrderBy {
  AffiliatePercent = 'affiliatePercent',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  IdGame = 'idGame',
  JackpotPercent = 'jackpotPercent',
  JackpotTerm = 'jackpotTerm',
  JackpotValue = 'jackpotValue',
  MegaGameContract = 'megaGameContract',
  MegaGameContractAffFee = 'megaGameContract__affFee',
  MegaGameContractBlockNumber = 'megaGameContract__blockNumber',
  MegaGameContractBlockTimestamp = 'megaGameContract__blockTimestamp',
  MegaGameContractContractGameNew = 'megaGameContract__contractGameNew',
  MegaGameContractContractGameOrigin = 'megaGameContract__contractGameOrigin',
  MegaGameContractContractToken = 'megaGameContract__contractToken',
  MegaGameContractDeployedFee = 'megaGameContract__deployedFee',
  MegaGameContractDevFee = 'megaGameContract__devFee',
  MegaGameContractId = 'megaGameContract__id',
  MegaGameContractMktFee = 'megaGameContract__mktFee',
  MegaGameContractName = 'megaGameContract__name',
  MegaGameContractOwnerFee = 'megaGameContract__ownerFee',
  MegaGameContractProjectId = 'megaGameContract__projectId',
  MegaGameContractTotalGame = 'megaGameContract__totalGame',
  MegaGameContractTotalPayAmount = 'megaGameContract__totalPayAmount',
  MegaGameContractTotalQuantity = 'megaGameContract__totalQuantity',
  MegaGameContractTotalTransactions = 'megaGameContract__totalTransactions',
  MegaGameContractTransactionHash = 'megaGameContract__transactionHash',
  NewGameContract = 'newGameContract',
  Orders = 'orders',
  OwnerFee = 'ownerFee',
  OwnerPercent = 'ownerPercent',
  Percents = 'percents',
  Price = 'price',
  StartPrice = 'startPrice',
  Title = 'title',
  TotalPayAmount = 'totalPayAmount',
  TotalQuantity = 'totalQuantity',
  TotalTransactions = 'totalTransactions',
  Values = 'values',
}

export type DataMaker = {
  __typename?: 'DataMaker'
  address: Scalars['Bytes']['output']
  id: Scalars['ID']['output']
  orders: Array<Order>
  totalQuantity: Scalars['BigInt']['output']
  totalReward: Scalars['BigInt']['output']
  totalTransactions: Scalars['BigInt']['output']
  totalVolume: Scalars['BigInt']['output']
}

export type DataMakerOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Order_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<Order_Filter>
}

export type DataMaker_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  address?: InputMaybe<Scalars['Bytes']['input']>
  address_contains?: InputMaybe<Scalars['Bytes']['input']>
  address_gt?: InputMaybe<Scalars['Bytes']['input']>
  address_gte?: InputMaybe<Scalars['Bytes']['input']>
  address_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  address_lt?: InputMaybe<Scalars['Bytes']['input']>
  address_lte?: InputMaybe<Scalars['Bytes']['input']>
  address_not?: InputMaybe<Scalars['Bytes']['input']>
  address_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  address_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  and?: InputMaybe<Array<InputMaybe<DataMaker_Filter>>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  or?: InputMaybe<Array<InputMaybe<DataMaker_Filter>>>
  orders_?: InputMaybe<Order_Filter>
  totalQuantity?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalQuantity_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalReward?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalReward_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_not?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalVolume?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalVolume_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_not?: InputMaybe<Scalars['BigInt']['input']>
  totalVolume_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

export enum DataMaker_OrderBy {
  Address = 'address',
  Id = 'id',
  Orders = 'orders',
  TotalQuantity = 'totalQuantity',
  TotalReward = 'totalReward',
  TotalTransactions = 'totalTransactions',
  TotalVolume = 'totalVolume',
}

export type MegaGameContract = {
  __typename?: 'MegaGameContract'
  affFee: Scalars['BigInt']['output']
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  contractGameNew: Scalars['Bytes']['output']
  contractGameOrigin: Scalars['Bytes']['output']
  contractToken: Scalars['Bytes']['output']
  createdGames: Array<CreateGame>
  deployedFee: Scalars['BigInt']['output']
  devFee: Scalars['BigInt']['output']
  id: Scalars['ID']['output']
  mktFee: Scalars['BigInt']['output']
  name: Scalars['String']['output']
  orders: Array<Order>
  ownerFee: Scalars['BigInt']['output']
  projectId: Scalars['String']['output']
  projectOwner: ProjectOwner
  system: System
  token: Token
  totalGame: Scalars['BigInt']['output']
  totalPayAmount: Scalars['BigInt']['output']
  totalQuantity: Scalars['BigInt']['output']
  totalTransactions: Scalars['BigInt']['output']
  transactionHash: Scalars['Bytes']['output']
}

export type MegaGameContractCreatedGamesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CreateGame_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<CreateGame_Filter>
}

export type MegaGameContractOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Order_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<Order_Filter>
}

export type MegaGameContract_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  affFee?: InputMaybe<Scalars['BigInt']['input']>
  affFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  affFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  affFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  affFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  affFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  affFee_not?: InputMaybe<Scalars['BigInt']['input']>
  affFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  and?: InputMaybe<Array<InputMaybe<MegaGameContract_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  contractGameNew?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_gt?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_gte?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractGameNew_lt?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_lte?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_not?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGameNew_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractGameOrigin?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_gt?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_gte?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractGameOrigin_lt?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_lte?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_not?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGameOrigin_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractToken?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_gt?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_gte?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractToken_lt?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_lte?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_not?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  createdGames_?: InputMaybe<CreateGame_Filter>
  deployedFee?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  deployedFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_not?: InputMaybe<Scalars['BigInt']['input']>
  deployedFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  devFee?: InputMaybe<Scalars['BigInt']['input']>
  devFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  devFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  devFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  devFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  devFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  devFee_not?: InputMaybe<Scalars['BigInt']['input']>
  devFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  mktFee?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  mktFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_not?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
  name_contains?: InputMaybe<Scalars['String']['input']>
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_gt?: InputMaybe<Scalars['String']['input']>
  name_gte?: InputMaybe<Scalars['String']['input']>
  name_in?: InputMaybe<Array<Scalars['String']['input']>>
  name_lt?: InputMaybe<Scalars['String']['input']>
  name_lte?: InputMaybe<Scalars['String']['input']>
  name_not?: InputMaybe<Scalars['String']['input']>
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  or?: InputMaybe<Array<InputMaybe<MegaGameContract_Filter>>>
  orders_?: InputMaybe<Order_Filter>
  ownerFee?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  ownerFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  projectId?: InputMaybe<Scalars['String']['input']>
  projectId_contains?: InputMaybe<Scalars['String']['input']>
  projectId_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_ends_with?: InputMaybe<Scalars['String']['input']>
  projectId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_gt?: InputMaybe<Scalars['String']['input']>
  projectId_gte?: InputMaybe<Scalars['String']['input']>
  projectId_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectId_lt?: InputMaybe<Scalars['String']['input']>
  projectId_lte?: InputMaybe<Scalars['String']['input']>
  projectId_not?: InputMaybe<Scalars['String']['input']>
  projectId_not_contains?: InputMaybe<Scalars['String']['input']>
  projectId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  projectId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  projectId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_starts_with?: InputMaybe<Scalars['String']['input']>
  projectId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner?: InputMaybe<Scalars['String']['input']>
  projectOwner_?: InputMaybe<ProjectOwner_Filter>
  projectOwner_contains?: InputMaybe<Scalars['String']['input']>
  projectOwner_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner_ends_with?: InputMaybe<Scalars['String']['input']>
  projectOwner_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner_gt?: InputMaybe<Scalars['String']['input']>
  projectOwner_gte?: InputMaybe<Scalars['String']['input']>
  projectOwner_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectOwner_lt?: InputMaybe<Scalars['String']['input']>
  projectOwner_lte?: InputMaybe<Scalars['String']['input']>
  projectOwner_not?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_contains?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_ends_with?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectOwner_not_starts_with?: InputMaybe<Scalars['String']['input']>
  projectOwner_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectOwner_starts_with?: InputMaybe<Scalars['String']['input']>
  projectOwner_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  system?: InputMaybe<Scalars['String']['input']>
  system_?: InputMaybe<System_Filter>
  system_contains?: InputMaybe<Scalars['String']['input']>
  system_contains_nocase?: InputMaybe<Scalars['String']['input']>
  system_ends_with?: InputMaybe<Scalars['String']['input']>
  system_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  system_gt?: InputMaybe<Scalars['String']['input']>
  system_gte?: InputMaybe<Scalars['String']['input']>
  system_in?: InputMaybe<Array<Scalars['String']['input']>>
  system_lt?: InputMaybe<Scalars['String']['input']>
  system_lte?: InputMaybe<Scalars['String']['input']>
  system_not?: InputMaybe<Scalars['String']['input']>
  system_not_contains?: InputMaybe<Scalars['String']['input']>
  system_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  system_not_ends_with?: InputMaybe<Scalars['String']['input']>
  system_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  system_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  system_not_starts_with?: InputMaybe<Scalars['String']['input']>
  system_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  system_starts_with?: InputMaybe<Scalars['String']['input']>
  system_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  token_?: InputMaybe<Token_Filter>
  token_contains?: InputMaybe<Scalars['String']['input']>
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>
  token_ends_with?: InputMaybe<Scalars['String']['input']>
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  token_gt?: InputMaybe<Scalars['String']['input']>
  token_gte?: InputMaybe<Scalars['String']['input']>
  token_in?: InputMaybe<Array<Scalars['String']['input']>>
  token_lt?: InputMaybe<Scalars['String']['input']>
  token_lte?: InputMaybe<Scalars['String']['input']>
  token_not?: InputMaybe<Scalars['String']['input']>
  token_not_contains?: InputMaybe<Scalars['String']['input']>
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  token_starts_with?: InputMaybe<Scalars['String']['input']>
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  totalGame?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalGame_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_not?: InputMaybe<Scalars['BigInt']['input']>
  totalGame_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalPayAmount?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalPayAmount_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_not?: InputMaybe<Scalars['BigInt']['input']>
  totalPayAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalQuantity?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalQuantity_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not?: InputMaybe<Scalars['BigInt']['input']>
  totalQuantity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalTransactions_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not?: InputMaybe<Scalars['BigInt']['input']>
  totalTransactions_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
}

export enum MegaGameContract_OrderBy {
  AffFee = 'affFee',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  ContractGameNew = 'contractGameNew',
  ContractGameOrigin = 'contractGameOrigin',
  ContractToken = 'contractToken',
  CreatedGames = 'createdGames',
  DeployedFee = 'deployedFee',
  DevFee = 'devFee',
  Id = 'id',
  MktFee = 'mktFee',
  Name = 'name',
  Orders = 'orders',
  OwnerFee = 'ownerFee',
  ProjectId = 'projectId',
  ProjectOwner = 'projectOwner',
  ProjectOwnerAddress = 'projectOwner__address',
  ProjectOwnerId = 'projectOwner__id',
  System = 'system',
  SystemId = 'system__id',
  SystemTotal = 'system__total',
  Token = 'token',
  TokenDecimals = 'token__decimals',
  TokenId = 'token__id',
  TokenName = 'token__name',
  TokenSymbol = 'token__symbol',
  TotalGame = 'totalGame',
  TotalPayAmount = 'totalPayAmount',
  TotalQuantity = 'totalQuantity',
  TotalTransactions = 'totalTransactions',
  TransactionHash = 'transactionHash',
}

export type Nft = {
  __typename?: 'NFT'
  id: Scalars['ID']['output']
  owner: Scalars['Bytes']['output']
  tokenId: Scalars['BigInt']['output']
  value: Scalars['BigInt']['output']
}

export type Nft_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  and?: InputMaybe<Array<InputMaybe<Nft_Filter>>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  or?: InputMaybe<Array<InputMaybe<Nft_Filter>>>
  owner?: InputMaybe<Scalars['Bytes']['input']>
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>
  owner_not?: InputMaybe<Scalars['Bytes']['input']>
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  tokenId?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  value?: InputMaybe<Scalars['BigInt']['input']>
  value_gt?: InputMaybe<Scalars['BigInt']['input']>
  value_gte?: InputMaybe<Scalars['BigInt']['input']>
  value_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  value_lt?: InputMaybe<Scalars['BigInt']['input']>
  value_lte?: InputMaybe<Scalars['BigInt']['input']>
  value_not?: InputMaybe<Scalars['BigInt']['input']>
  value_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

export enum Nft_OrderBy {
  Id = 'id',
  Owner = 'owner',
  TokenId = 'tokenId',
  Value = 'value',
}

export type Order = {
  __typename?: 'Order'
  amount: Scalars['BigInt']['output']
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  contractGame: Scalars['Bytes']['output']
  game: CreateGame
  id: Scalars['ID']['output']
  idGame: Scalars['BigInt']['output']
  maker: DataMaker
  megaGameContract: MegaGameContract
  orderDetail: OrderDetail
  projectId: Scalars['String']['output']
  qty: Scalars['BigInt']['output']
  tokenId: Scalars['BigInt']['output']
  transactionHash: Scalars['Bytes']['output']
}

export type OrderDetail = {
  __typename?: 'OrderDetail'
  affFee: Scalars['BigInt']['output']
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  devFee: Scalars['BigInt']['output']
  id: Scalars['ID']['output']
  idGame: Scalars['BigInt']['output']
  mktFee: Scalars['BigInt']['output']
  orderRewards: Array<OrderReward>
  ownerFee: Scalars['BigInt']['output']
  totalReward: Scalars['BigInt']['output']
  win: Scalars['Boolean']['output']
}

export type OrderDetailOrderRewardsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderReward_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<OrderReward_Filter>
}

export type OrderDetail_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  affFee?: InputMaybe<Scalars['BigInt']['input']>
  affFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  affFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  affFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  affFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  affFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  affFee_not?: InputMaybe<Scalars['BigInt']['input']>
  affFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  and?: InputMaybe<Array<InputMaybe<OrderDetail_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  devFee?: InputMaybe<Scalars['BigInt']['input']>
  devFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  devFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  devFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  devFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  devFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  devFee_not?: InputMaybe<Scalars['BigInt']['input']>
  devFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  idGame?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  idGame_lt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_lte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  mktFee?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  mktFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_not?: InputMaybe<Scalars['BigInt']['input']>
  mktFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  or?: InputMaybe<Array<InputMaybe<OrderDetail_Filter>>>
  orderRewards_?: InputMaybe<OrderReward_Filter>
  ownerFee?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_gte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  ownerFee_lt?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_lte?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not?: InputMaybe<Scalars['BigInt']['input']>
  ownerFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalReward?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_gt?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_gte?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  totalReward_lt?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_lte?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_not?: InputMaybe<Scalars['BigInt']['input']>
  totalReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  win?: InputMaybe<Scalars['Boolean']['input']>
  win_in?: InputMaybe<Array<Scalars['Boolean']['input']>>
  win_not?: InputMaybe<Scalars['Boolean']['input']>
  win_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

export enum OrderDetail_OrderBy {
  AffFee = 'affFee',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  DevFee = 'devFee',
  Id = 'id',
  IdGame = 'idGame',
  MktFee = 'mktFee',
  OrderRewards = 'orderRewards',
  OwnerFee = 'ownerFee',
  TotalReward = 'totalReward',
  Win = 'win',
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type OrderReward = {
  __typename?: 'OrderReward'
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  gameContract: Scalars['Bytes']['output']
  id: Scalars['ID']['output']
  idGame: Scalars['BigInt']['output']
  orderDetail: OrderDetail
  quantity: Scalars['BigInt']['output']
  tokenId: Scalars['BigInt']['output']
  transactionHash: Scalars['Bytes']['output']
  values: Scalars['BigInt']['output']
}

export type OrderReward_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  and?: InputMaybe<Array<InputMaybe<OrderReward_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  gameContract?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_contains?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_gt?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_gte?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  gameContract_lt?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_lte?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_not?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  gameContract_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  idGame?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  idGame_lt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_lte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  or?: InputMaybe<Array<InputMaybe<OrderReward_Filter>>>
  orderDetail?: InputMaybe<Scalars['String']['input']>
  orderDetail_?: InputMaybe<OrderDetail_Filter>
  orderDetail_contains?: InputMaybe<Scalars['String']['input']>
  orderDetail_contains_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_ends_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_gt?: InputMaybe<Scalars['String']['input']>
  orderDetail_gte?: InputMaybe<Scalars['String']['input']>
  orderDetail_in?: InputMaybe<Array<Scalars['String']['input']>>
  orderDetail_lt?: InputMaybe<Scalars['String']['input']>
  orderDetail_lte?: InputMaybe<Scalars['String']['input']>
  orderDetail_not?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_contains?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_ends_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  orderDetail_not_starts_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_starts_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['BigInt']['input']>
  quantity_gt?: InputMaybe<Scalars['BigInt']['input']>
  quantity_gte?: InputMaybe<Scalars['BigInt']['input']>
  quantity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  quantity_lt?: InputMaybe<Scalars['BigInt']['input']>
  quantity_lte?: InputMaybe<Scalars['BigInt']['input']>
  quantity_not?: InputMaybe<Scalars['BigInt']['input']>
  quantity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  tokenId?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  values?: InputMaybe<Scalars['BigInt']['input']>
  values_gt?: InputMaybe<Scalars['BigInt']['input']>
  values_gte?: InputMaybe<Scalars['BigInt']['input']>
  values_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  values_lt?: InputMaybe<Scalars['BigInt']['input']>
  values_lte?: InputMaybe<Scalars['BigInt']['input']>
  values_not?: InputMaybe<Scalars['BigInt']['input']>
  values_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

export enum OrderReward_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  GameContract = 'gameContract',
  Id = 'id',
  IdGame = 'idGame',
  OrderDetail = 'orderDetail',
  OrderDetailAffFee = 'orderDetail__affFee',
  OrderDetailBlockNumber = 'orderDetail__blockNumber',
  OrderDetailBlockTimestamp = 'orderDetail__blockTimestamp',
  OrderDetailDevFee = 'orderDetail__devFee',
  OrderDetailId = 'orderDetail__id',
  OrderDetailIdGame = 'orderDetail__idGame',
  OrderDetailMktFee = 'orderDetail__mktFee',
  OrderDetailOwnerFee = 'orderDetail__ownerFee',
  OrderDetailTotalReward = 'orderDetail__totalReward',
  OrderDetailWin = 'orderDetail__win',
  Quantity = 'quantity',
  TokenId = 'tokenId',
  TransactionHash = 'transactionHash',
  Values = 'values',
}

export type Order_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  amount?: InputMaybe<Scalars['BigInt']['input']>
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>
  amount_not?: InputMaybe<Scalars['BigInt']['input']>
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  and?: InputMaybe<Array<InputMaybe<Order_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  contractGame?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_gt?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_gte?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  contractGame_lt?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_lte?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_not?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  contractGame_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  game?: InputMaybe<Scalars['String']['input']>
  game_?: InputMaybe<CreateGame_Filter>
  game_contains?: InputMaybe<Scalars['String']['input']>
  game_contains_nocase?: InputMaybe<Scalars['String']['input']>
  game_ends_with?: InputMaybe<Scalars['String']['input']>
  game_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  game_gt?: InputMaybe<Scalars['String']['input']>
  game_gte?: InputMaybe<Scalars['String']['input']>
  game_in?: InputMaybe<Array<Scalars['String']['input']>>
  game_lt?: InputMaybe<Scalars['String']['input']>
  game_lte?: InputMaybe<Scalars['String']['input']>
  game_not?: InputMaybe<Scalars['String']['input']>
  game_not_contains?: InputMaybe<Scalars['String']['input']>
  game_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  game_not_ends_with?: InputMaybe<Scalars['String']['input']>
  game_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  game_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  game_not_starts_with?: InputMaybe<Scalars['String']['input']>
  game_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  game_starts_with?: InputMaybe<Scalars['String']['input']>
  game_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  idGame?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_gte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  idGame_lt?: InputMaybe<Scalars['BigInt']['input']>
  idGame_lte?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not?: InputMaybe<Scalars['BigInt']['input']>
  idGame_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  maker?: InputMaybe<Scalars['String']['input']>
  maker_?: InputMaybe<DataMaker_Filter>
  maker_contains?: InputMaybe<Scalars['String']['input']>
  maker_contains_nocase?: InputMaybe<Scalars['String']['input']>
  maker_ends_with?: InputMaybe<Scalars['String']['input']>
  maker_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  maker_gt?: InputMaybe<Scalars['String']['input']>
  maker_gte?: InputMaybe<Scalars['String']['input']>
  maker_in?: InputMaybe<Array<Scalars['String']['input']>>
  maker_lt?: InputMaybe<Scalars['String']['input']>
  maker_lte?: InputMaybe<Scalars['String']['input']>
  maker_not?: InputMaybe<Scalars['String']['input']>
  maker_not_contains?: InputMaybe<Scalars['String']['input']>
  maker_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  maker_not_ends_with?: InputMaybe<Scalars['String']['input']>
  maker_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  maker_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  maker_not_starts_with?: InputMaybe<Scalars['String']['input']>
  maker_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  maker_starts_with?: InputMaybe<Scalars['String']['input']>
  maker_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract?: InputMaybe<Scalars['String']['input']>
  megaGameContract_?: InputMaybe<MegaGameContract_Filter>
  megaGameContract_contains?: InputMaybe<Scalars['String']['input']>
  megaGameContract_contains_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_ends_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_gt?: InputMaybe<Scalars['String']['input']>
  megaGameContract_gte?: InputMaybe<Scalars['String']['input']>
  megaGameContract_in?: InputMaybe<Array<Scalars['String']['input']>>
  megaGameContract_lt?: InputMaybe<Scalars['String']['input']>
  megaGameContract_lte?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_contains?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_ends_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  megaGameContract_not_starts_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  megaGameContract_starts_with?: InputMaybe<Scalars['String']['input']>
  megaGameContract_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  or?: InputMaybe<Array<InputMaybe<Order_Filter>>>
  orderDetail?: InputMaybe<Scalars['String']['input']>
  orderDetail_?: InputMaybe<OrderDetail_Filter>
  orderDetail_contains?: InputMaybe<Scalars['String']['input']>
  orderDetail_contains_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_ends_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_gt?: InputMaybe<Scalars['String']['input']>
  orderDetail_gte?: InputMaybe<Scalars['String']['input']>
  orderDetail_in?: InputMaybe<Array<Scalars['String']['input']>>
  orderDetail_lt?: InputMaybe<Scalars['String']['input']>
  orderDetail_lte?: InputMaybe<Scalars['String']['input']>
  orderDetail_not?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_contains?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_ends_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  orderDetail_not_starts_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  orderDetail_starts_with?: InputMaybe<Scalars['String']['input']>
  orderDetail_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId?: InputMaybe<Scalars['String']['input']>
  projectId_contains?: InputMaybe<Scalars['String']['input']>
  projectId_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_ends_with?: InputMaybe<Scalars['String']['input']>
  projectId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_gt?: InputMaybe<Scalars['String']['input']>
  projectId_gte?: InputMaybe<Scalars['String']['input']>
  projectId_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectId_lt?: InputMaybe<Scalars['String']['input']>
  projectId_lte?: InputMaybe<Scalars['String']['input']>
  projectId_not?: InputMaybe<Scalars['String']['input']>
  projectId_not_contains?: InputMaybe<Scalars['String']['input']>
  projectId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_not_ends_with?: InputMaybe<Scalars['String']['input']>
  projectId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  projectId_not_starts_with?: InputMaybe<Scalars['String']['input']>
  projectId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  projectId_starts_with?: InputMaybe<Scalars['String']['input']>
  projectId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  qty?: InputMaybe<Scalars['BigInt']['input']>
  qty_gt?: InputMaybe<Scalars['BigInt']['input']>
  qty_gte?: InputMaybe<Scalars['BigInt']['input']>
  qty_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  qty_lt?: InputMaybe<Scalars['BigInt']['input']>
  qty_lte?: InputMaybe<Scalars['BigInt']['input']>
  qty_not?: InputMaybe<Scalars['BigInt']['input']>
  qty_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  tokenId?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
}

export enum Order_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  ContractGame = 'contractGame',
  Game = 'game',
  GameAffiliatePercent = 'game__affiliatePercent',
  GameBlockNumber = 'game__blockNumber',
  GameBlockTimestamp = 'game__blockTimestamp',
  GameId = 'game__id',
  GameIdGame = 'game__idGame',
  GameJackpotPercent = 'game__jackpotPercent',
  GameJackpotTerm = 'game__jackpotTerm',
  GameJackpotValue = 'game__jackpotValue',
  GameNewGameContract = 'game__newGameContract',
  GameOwnerFee = 'game__ownerFee',
  GameOwnerPercent = 'game__ownerPercent',
  GamePrice = 'game__price',
  GameStartPrice = 'game__startPrice',
  GameTitle = 'game__title',
  GameTotalPayAmount = 'game__totalPayAmount',
  GameTotalQuantity = 'game__totalQuantity',
  GameTotalTransactions = 'game__totalTransactions',
  Id = 'id',
  IdGame = 'idGame',
  Maker = 'maker',
  MakerAddress = 'maker__address',
  MakerId = 'maker__id',
  MakerTotalQuantity = 'maker__totalQuantity',
  MakerTotalReward = 'maker__totalReward',
  MakerTotalTransactions = 'maker__totalTransactions',
  MakerTotalVolume = 'maker__totalVolume',
  MegaGameContract = 'megaGameContract',
  MegaGameContractAffFee = 'megaGameContract__affFee',
  MegaGameContractBlockNumber = 'megaGameContract__blockNumber',
  MegaGameContractBlockTimestamp = 'megaGameContract__blockTimestamp',
  MegaGameContractContractGameNew = 'megaGameContract__contractGameNew',
  MegaGameContractContractGameOrigin = 'megaGameContract__contractGameOrigin',
  MegaGameContractContractToken = 'megaGameContract__contractToken',
  MegaGameContractDeployedFee = 'megaGameContract__deployedFee',
  MegaGameContractDevFee = 'megaGameContract__devFee',
  MegaGameContractId = 'megaGameContract__id',
  MegaGameContractMktFee = 'megaGameContract__mktFee',
  MegaGameContractName = 'megaGameContract__name',
  MegaGameContractOwnerFee = 'megaGameContract__ownerFee',
  MegaGameContractProjectId = 'megaGameContract__projectId',
  MegaGameContractTotalGame = 'megaGameContract__totalGame',
  MegaGameContractTotalPayAmount = 'megaGameContract__totalPayAmount',
  MegaGameContractTotalQuantity = 'megaGameContract__totalQuantity',
  MegaGameContractTotalTransactions = 'megaGameContract__totalTransactions',
  MegaGameContractTransactionHash = 'megaGameContract__transactionHash',
  OrderDetail = 'orderDetail',
  OrderDetailAffFee = 'orderDetail__affFee',
  OrderDetailBlockNumber = 'orderDetail__blockNumber',
  OrderDetailBlockTimestamp = 'orderDetail__blockTimestamp',
  OrderDetailDevFee = 'orderDetail__devFee',
  OrderDetailId = 'orderDetail__id',
  OrderDetailIdGame = 'orderDetail__idGame',
  OrderDetailMktFee = 'orderDetail__mktFee',
  OrderDetailOwnerFee = 'orderDetail__ownerFee',
  OrderDetailTotalReward = 'orderDetail__totalReward',
  OrderDetailWin = 'orderDetail__win',
  ProjectId = 'projectId',
  Qty = 'qty',
  TokenId = 'tokenId',
  TransactionHash = 'transactionHash',
}

export type OwnershipTransferred = {
  __typename?: 'OwnershipTransferred'
  blockNumber: Scalars['BigInt']['output']
  blockTimestamp: Scalars['BigInt']['output']
  id: Scalars['Bytes']['output']
  newOwner: Scalars['Bytes']['output']
  previousOwner: Scalars['Bytes']['output']
  transactionHash: Scalars['Bytes']['output']
}

export type OwnershipTransferred_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  and?: InputMaybe<Array<InputMaybe<OwnershipTransferred_Filter>>>
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id?: InputMaybe<Scalars['Bytes']['input']>
  id_contains?: InputMaybe<Scalars['Bytes']['input']>
  id_gt?: InputMaybe<Scalars['Bytes']['input']>
  id_gte?: InputMaybe<Scalars['Bytes']['input']>
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  id_lt?: InputMaybe<Scalars['Bytes']['input']>
  id_lte?: InputMaybe<Scalars['Bytes']['input']>
  id_not?: InputMaybe<Scalars['Bytes']['input']>
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  newOwner?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_contains?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_gt?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_gte?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  newOwner_lt?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_lte?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_not?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  newOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  or?: InputMaybe<Array<InputMaybe<OwnershipTransferred_Filter>>>
  previousOwner?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_contains?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_gt?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_gte?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  previousOwner_lt?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_lte?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_not?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  previousOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
}

export enum OwnershipTransferred_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  NewOwner = 'newOwner',
  PreviousOwner = 'previousOwner',
  TransactionHash = 'transactionHash',
}

export type ProjectOwner = {
  __typename?: 'ProjectOwner'
  address: Scalars['Bytes']['output']
  id: Scalars['ID']['output']
  megaGameContracts: Array<MegaGameContract>
}

export type ProjectOwnerMegaGameContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<MegaGameContract_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MegaGameContract_Filter>
}

export type ProjectOwner_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  address?: InputMaybe<Scalars['Bytes']['input']>
  address_contains?: InputMaybe<Scalars['Bytes']['input']>
  address_gt?: InputMaybe<Scalars['Bytes']['input']>
  address_gte?: InputMaybe<Scalars['Bytes']['input']>
  address_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  address_lt?: InputMaybe<Scalars['Bytes']['input']>
  address_lte?: InputMaybe<Scalars['Bytes']['input']>
  address_not?: InputMaybe<Scalars['Bytes']['input']>
  address_not_contains?: InputMaybe<Scalars['Bytes']['input']>
  address_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>
  and?: InputMaybe<Array<InputMaybe<ProjectOwner_Filter>>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  megaGameContracts_?: InputMaybe<MegaGameContract_Filter>
  or?: InputMaybe<Array<InputMaybe<ProjectOwner_Filter>>>
}

export enum ProjectOwner_OrderBy {
  Address = 'address',
  Id = 'id',
  MegaGameContracts = 'megaGameContracts',
}

export type Query = {
  __typename?: 'Query'
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>
  createGame?: Maybe<CreateGame>
  createGames: Array<CreateGame>
  dataMaker?: Maybe<DataMaker>
  dataMakers: Array<DataMaker>
  megaGameContract?: Maybe<MegaGameContract>
  megaGameContracts: Array<MegaGameContract>
  nft?: Maybe<Nft>
  nfts: Array<Nft>
  order?: Maybe<Order>
  orderDetail?: Maybe<OrderDetail>
  orderDetails: Array<OrderDetail>
  orderReward?: Maybe<OrderReward>
  orderRewards: Array<OrderReward>
  orders: Array<Order>
  ownershipTransferred?: Maybe<OwnershipTransferred>
  ownershipTransferreds: Array<OwnershipTransferred>
  projectOwner?: Maybe<ProjectOwner>
  projectOwners: Array<ProjectOwner>
  system?: Maybe<System>
  systems: Array<System>
  token?: Maybe<Token>
  tokens: Array<Token>
}

export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>
}

export type QueryCreateGameArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryCreateGamesArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CreateGame_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<CreateGame_Filter>
}

export type QueryDataMakerArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryDataMakersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<DataMaker_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<DataMaker_Filter>
}

export type QueryMegaGameContractArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryMegaGameContractsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<MegaGameContract_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<MegaGameContract_Filter>
}

export type QueryNftArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryNftsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Nft_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Nft_Filter>
}

export type QueryOrderArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOrderDetailArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOrderDetailsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderDetail_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OrderDetail_Filter>
}

export type QueryOrderRewardArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOrderRewardsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderReward_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OrderReward_Filter>
}

export type QueryOrdersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Order_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Order_Filter>
}

export type QueryOwnershipTransferredArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryOwnershipTransferredsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OwnershipTransferred_Filter>
}

export type QueryProjectOwnerArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryProjectOwnersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ProjectOwner_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<ProjectOwner_Filter>
}

export type QuerySystemArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QuerySystemsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<System_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<System_Filter>
}

export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Token_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Token_Filter>
}

export type Subscription = {
  __typename?: 'Subscription'
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>
  createGame?: Maybe<CreateGame>
  createGames: Array<CreateGame>
  dataMaker?: Maybe<DataMaker>
  dataMakers: Array<DataMaker>
  megaGameContract?: Maybe<MegaGameContract>
  megaGameContracts: Array<MegaGameContract>
  nft?: Maybe<Nft>
  nfts: Array<Nft>
  order?: Maybe<Order>
  orderDetail?: Maybe<OrderDetail>
  orderDetails: Array<OrderDetail>
  orderReward?: Maybe<OrderReward>
  orderRewards: Array<OrderReward>
  orders: Array<Order>
  ownershipTransferred?: Maybe<OwnershipTransferred>
  ownershipTransferreds: Array<OwnershipTransferred>
  projectOwner?: Maybe<ProjectOwner>
  projectOwners: Array<ProjectOwner>
  system?: Maybe<System>
  systems: Array<System>
  token?: Maybe<Token>
  tokens: Array<Token>
}

export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>
}

export type SubscriptionCreateGameArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionCreateGamesArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CreateGame_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<CreateGame_Filter>
}

export type SubscriptionDataMakerArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionDataMakersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<DataMaker_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<DataMaker_Filter>
}

export type SubscriptionMegaGameContractArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionMegaGameContractsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<MegaGameContract_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<MegaGameContract_Filter>
}

export type SubscriptionNftArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionNftsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Nft_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Nft_Filter>
}

export type SubscriptionOrderArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOrderDetailArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOrderDetailsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderDetail_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OrderDetail_Filter>
}

export type SubscriptionOrderRewardArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOrderRewardsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderReward_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OrderReward_Filter>
}

export type SubscriptionOrdersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Order_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Order_Filter>
}

export type SubscriptionOwnershipTransferredArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionOwnershipTransferredsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OwnershipTransferred_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<OwnershipTransferred_Filter>
}

export type SubscriptionProjectOwnerArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionProjectOwnersArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ProjectOwner_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<ProjectOwner_Filter>
}

export type SubscriptionSystemArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionSystemsArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<System_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<System_Filter>
}

export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>
  id: Scalars['ID']['input']
  subgraphError?: _SubgraphErrorPolicy_
}

export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Token_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  subgraphError?: _SubgraphErrorPolicy_
  where?: InputMaybe<Token_Filter>
}

export type System = {
  __typename?: 'System'
  id: Scalars['ID']['output']
  megaGameContract: Array<MegaGameContract>
  total: Scalars['BigInt']['output']
}

export type SystemMegaGameContractArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<MegaGameContract_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MegaGameContract_Filter>
}

export type System_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  and?: InputMaybe<Array<InputMaybe<System_Filter>>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  megaGameContract_?: InputMaybe<MegaGameContract_Filter>
  or?: InputMaybe<Array<InputMaybe<System_Filter>>>
  total?: InputMaybe<Scalars['BigInt']['input']>
  total_gt?: InputMaybe<Scalars['BigInt']['input']>
  total_gte?: InputMaybe<Scalars['BigInt']['input']>
  total_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  total_lt?: InputMaybe<Scalars['BigInt']['input']>
  total_lte?: InputMaybe<Scalars['BigInt']['input']>
  total_not?: InputMaybe<Scalars['BigInt']['input']>
  total_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

export enum System_OrderBy {
  Id = 'id',
  MegaGameContract = 'megaGameContract',
  Total = 'total',
}

export type Token = {
  __typename?: 'Token'
  decimals: Scalars['BigInt']['output']
  id: Scalars['ID']['output']
  megaGameContracts: Array<MegaGameContract>
  name: Scalars['String']['output']
  symbol: Scalars['String']['output']
}

export type TokenMegaGameContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<MegaGameContract_OrderBy>
  orderDirection?: InputMaybe<OrderDirection>
  skip?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MegaGameContract_Filter>
}

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>
  decimals?: InputMaybe<Scalars['BigInt']['input']>
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>
  id?: InputMaybe<Scalars['ID']['input']>
  id_gt?: InputMaybe<Scalars['ID']['input']>
  id_gte?: InputMaybe<Scalars['ID']['input']>
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>
  id_lt?: InputMaybe<Scalars['ID']['input']>
  id_lte?: InputMaybe<Scalars['ID']['input']>
  id_not?: InputMaybe<Scalars['ID']['input']>
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>
  megaGameContracts_?: InputMaybe<MegaGameContract_Filter>
  name?: InputMaybe<Scalars['String']['input']>
  name_contains?: InputMaybe<Scalars['String']['input']>
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>
  name_ends_with?: InputMaybe<Scalars['String']['input']>
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_gt?: InputMaybe<Scalars['String']['input']>
  name_gte?: InputMaybe<Scalars['String']['input']>
  name_in?: InputMaybe<Array<Scalars['String']['input']>>
  name_lt?: InputMaybe<Scalars['String']['input']>
  name_lte?: InputMaybe<Scalars['String']['input']>
  name_not?: InputMaybe<Scalars['String']['input']>
  name_not_contains?: InputMaybe<Scalars['String']['input']>
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  name_starts_with?: InputMaybe<Scalars['String']['input']>
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>
  symbol?: InputMaybe<Scalars['String']['input']>
  symbol_contains?: InputMaybe<Scalars['String']['input']>
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  symbol_gt?: InputMaybe<Scalars['String']['input']>
  symbol_gte?: InputMaybe<Scalars['String']['input']>
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>
  symbol_lt?: InputMaybe<Scalars['String']['input']>
  symbol_lte?: InputMaybe<Scalars['String']['input']>
  symbol_not?: InputMaybe<Scalars['String']['input']>
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>
}

export enum Token_OrderBy {
  Decimals = 'decimals',
  Id = 'id',
  MegaGameContracts = 'megaGameContracts',
  Name = 'name',
  Symbol = 'symbol',
}

export type _Block_ = {
  __typename?: '_Block_'
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>
  /** The block number */
  number: Scalars['Int']['output']
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>
}

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_'
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_
  /** The deployment ID */
  deployment: Scalars['String']['output']
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output']
}

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny',
}

export type GetMegaGameContractsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>
}>

export type GetMegaGameContractsQuery = {
  __typename?: 'Query'
  megaGameContracts: Array<{
    __typename?: 'MegaGameContract'
    id: string
    name: string
    projectId: string
    totalGame: any
    totalPayAmount: any
    totalQuantity: any
    totalTransactions: any
    transactionHash: any
    mktFee: any
    deployedFee: any
    devFee: any
    contractToken: any
    contractGameOrigin: any
    contractGameNew: any
    blockTimestamp: any
    blockNumber: any
    affFee: any
    createdGames: Array<{
      __typename?: 'CreateGame'
      id: string
      idGame: any
      newGameContract: any
      ownerPercent: any
      percents?: Array<any> | null
      price: any
      startPrice: any
      title: string
      totalPayAmount: any
      totalQuantity: any
      totalTransactions: any
      values?: Array<any> | null
      jackpotValue: any
      jackpotTerm: any
      jackpotPercent: any
      affiliatePercent: any
    }>
    token: { __typename?: 'Token'; id: string; decimals: any; name: string; symbol: string }
  }>
}

export type GetTransactionQueryVariables = Exact<{
  gameId?: InputMaybe<Scalars['BigInt']['input']>
}>

export type GetTransactionQuery = {
  __typename?: 'Query'
  orders: Array<{
    __typename?: 'Order'
    qty: any
    tokenId: any
    transactionHash: any
    idGame: any
    id: string
    blockTimestamp: any
    blockNumber: any
    contractGame: any
    amount: any
    orderDetail: {
      __typename?: 'OrderDetail'
      win: boolean
      ownerFee: any
      affFee: any
      devFee: any
      id: string
      idGame: any
      mktFee: any
      totalReward: any
      orderRewards: Array<{
        __typename?: 'OrderReward'
        values: any
        transactionHash: any
        quantity: any
        tokenId: any
        idGame: any
        id: string
      }>
    }
    maker: { __typename?: 'DataMaker'; address: any; id: string }
  }>
}

export type GetCreateGameQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetCreateGameQuery = {
  __typename?: 'Query'
  createGame?: {
    __typename?: 'CreateGame'
    affiliatePercent: any
    id: string
    idGame: any
    jackpotPercent: any
    jackpotTerm: any
    jackpotValue: any
    newGameContract: any
    ownerFee: any
    ownerPercent: any
    percents?: Array<any> | null
    price: any
    startPrice: any
    title: string
    totalPayAmount: any
    totalQuantity: any
    totalTransactions: any
    values?: Array<any> | null
    megaGameContract: {
      __typename?: 'MegaGameContract'
      projectId: string
      contractGameNew: any
      contractGameOrigin: any
      totalPayAmount: any
      totalGame: any
      totalQuantity: any
      totalTransactions: any
      transactionHash: any
      token: { __typename?: 'Token'; symbol: string; name: string; id: string; decimals: any }
    }
    orders: Array<{
      __typename?: 'Order'
      projectId: string
      qty: any
      tokenId: any
      transactionHash: any
      id: string
      idGame: any
      amount: any
      blockNumber: any
      blockTimestamp: any
      contractGame: any
      maker: {
        __typename?: 'DataMaker'
        address: any
        id: string
        totalQuantity: any
        totalReward: any
        totalTransactions: any
        totalVolume: any
      }
      orderDetail: { __typename?: 'OrderDetail'; id: string; totalReward: any; win: boolean }
    }>
  } | null
}

export type GetOrderRewardQueryVariables = Exact<{
  idGame?: InputMaybe<Scalars['BigInt']['input']>
  gameContract?: InputMaybe<Scalars['Bytes']['input']>
}>

export type GetOrderRewardQuery = {
  __typename?: 'Query'
  orderRewards: Array<{
    __typename?: 'OrderReward'
    values: any
    transactionHash: any
    idGame: any
    id: string
    gameContract: any
    quantity: any
    tokenId: any
  }>
}

export type GetPopularSpinQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}>

export type GetPopularSpinQuery = {
  __typename?: 'Query'
  createGames: Array<{
    __typename?: 'CreateGame'
    id: string
    title: string
    values?: Array<any> | null
    totalTransactions: any
    totalQuantity: any
    totalPayAmount: any
    startPrice: any
    price: any
    percents?: Array<any> | null
    ownerPercent: any
    newGameContract: any
    jackpotValue: any
    jackpotTerm: any
    jackpotPercent: any
    idGame: any
    affiliatePercent: any
    ownerFee: any
    megaGameContract: {
      __typename?: 'MegaGameContract'
      affFee: any
      blockNumber: any
      blockTimestamp: any
      contractGameNew: any
      contractGameOrigin: any
      contractToken: any
      deployedFee: any
      id: string
      devFee: any
      name: string
      mktFee: any
      projectId: string
      ownerFee: any
      totalGame: any
      totalPayAmount: any
      totalQuantity: any
      totalTransactions: any
      transactionHash: any
      token: { __typename?: 'Token'; id: string; name: string; decimals: any; symbol: string }
    }
    orders: Array<{
      __typename?: 'Order'
      id: string
      idGame: any
      blockNumber: any
      blockTimestamp: any
      contractGame: any
      qty: any
      projectId: string
      tokenId: any
    }>
  }>
}

export type GetProjectJackpotsQueryVariables = Exact<{
  megaGameContract?: InputMaybe<Scalars['String']['input']>
  skip?: InputMaybe<Scalars['Int']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}>

export type GetProjectJackpotsQuery = {
  __typename?: 'Query'
  createGames: Array<{
    __typename?: 'CreateGame'
    idGame: any
    jackpotTerm: any
    jackpotPercent: any
    jackpotValue: any
    newGameContract: any
    ownerFee: any
    ownerPercent: any
    percents?: Array<any> | null
    price: any
    startPrice: any
    title: string
    totalPayAmount: any
    totalQuantity: any
    totalTransactions: any
    values?: Array<any> | null
    id: string
    blockNumber: any
    blockTimestamp: any
    orders: Array<{
      __typename?: 'Order'
      amount: any
      blockNumber: any
      blockTimestamp: any
      contractGame: any
      id: string
      idGame: any
      projectId: string
      qty: any
      tokenId: any
      transactionHash: any
      maker: {
        __typename?: 'DataMaker'
        address: any
        id: string
        totalVolume: any
        totalTransactions: any
        totalReward: any
        totalQuantity: any
      }
    }>
  }>
}

export type GetTotalParticipantsQueryVariables = Exact<{ [key: string]: never }>

export type GetTotalParticipantsQuery = { __typename?: 'Query'; orders: Array<{ __typename?: 'Order'; qty: any }> }

export type GetProjectParticipantQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>
}>

export type GetProjectParticipantQuery = { __typename?: 'Query'; orders: Array<{ __typename?: 'Order'; qty: any }> }

export type GetProjectStatisticQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>
}>

export type GetProjectStatisticQuery = {
  __typename?: 'Query'
  orders: Array<{ __typename?: 'Order'; amount: any; blockTimestamp: any; blockNumber: any; qty: any; id: string }>
}

export type GetSpinResultsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetSpinResultsQuery = {
  __typename?: 'Query'
  orderDetail?: {
    __typename?: 'OrderDetail'
    win: boolean
    totalReward: any
    ownerFee: any
    idGame: any
    affFee: any
    devFee: any
    mktFee: any
    id: string
    orderRewards: Array<{
      __typename?: 'OrderReward'
      values: any
      quantity: any
      idGame: any
      id: string
      tokenId: any
      gameContract: any
      transactionHash: any
      orderDetail: {
        __typename?: 'OrderDetail'
        win: boolean
        devFee: any
        affFee: any
        orderRewards: Array<{ __typename?: 'OrderReward'; values: any }>
      }
    }>
  } | null
}

export const GetMegaGameContractsDocument = gql`
  query getMegaGameContracts($projectId: String) {
    megaGameContracts(where: { projectId: $projectId }) {
      id
      name
      projectId
      totalGame
      totalPayAmount
      totalQuantity
      totalTransactions
      transactionHash
      mktFee
      deployedFee
      devFee
      contractToken
      contractGameOrigin
      contractGameNew
      blockTimestamp
      blockNumber
      affFee
      createdGames {
        id
        idGame
        newGameContract
        ownerPercent
        percents
        price
        startPrice
        title
        totalPayAmount
        totalQuantity
        totalTransactions
        values
        jackpotValue
        jackpotTerm
        jackpotPercent
        affiliatePercent
      }
      token {
        id
        decimals
        name
        symbol
      }
    }
  }
`

/**
 * __useGetMegaGameContractsQuery__
 *
 * To run a query within a React component, call `useGetMegaGameContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMegaGameContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMegaGameContractsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMegaGameContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>(
    GetMegaGameContractsDocument,
    options,
  )
}
export function useGetMegaGameContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>(
    GetMegaGameContractsDocument,
    options,
  )
}
export function useGetMegaGameContractsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMegaGameContractsQuery, GetMegaGameContractsQueryVariables>(
    GetMegaGameContractsDocument,
    options,
  )
}
export type GetMegaGameContractsQueryHookResult = ReturnType<typeof useGetMegaGameContractsQuery>
export type GetMegaGameContractsLazyQueryHookResult = ReturnType<typeof useGetMegaGameContractsLazyQuery>
export type GetMegaGameContractsSuspenseQueryHookResult = ReturnType<typeof useGetMegaGameContractsSuspenseQuery>
export type GetMegaGameContractsQueryResult = Apollo.QueryResult<
  GetMegaGameContractsQuery,
  GetMegaGameContractsQueryVariables
>
export const GetTransactionDocument = gql`
  query getTransaction($gameId: BigInt) {
    orders(where: { idGame: $gameId }) {
      qty
      tokenId
      transactionHash
      idGame
      id
      blockTimestamp
      blockNumber
      contractGame
      amount
      orderDetail {
        win
        ownerFee
        affFee
        devFee
        id
        idGame
        mktFee
        totalReward
        orderRewards {
          values
          transactionHash
          quantity
          tokenId
          idGame
          id
        }
      }
      maker {
        address
        id
      }
    }
  }
`

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetTransactionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options)
}
export function useGetTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options)
}
export function useGetTransactionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options)
}
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>
export type GetTransactionSuspenseQueryHookResult = ReturnType<typeof useGetTransactionSuspenseQuery>
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>
export const GetCreateGameDocument = gql`
  query getCreateGame($id: ID!) {
    createGame(id: $id) {
      affiliatePercent
      id
      idGame
      jackpotPercent
      jackpotTerm
      jackpotValue
      newGameContract
      ownerFee
      ownerPercent
      percents
      price
      startPrice
      title
      totalPayAmount
      totalQuantity
      totalTransactions
      values
      megaGameContract {
        token {
          symbol
          name
          id
          decimals
        }
        projectId
        contractGameNew
        contractGameOrigin
        totalPayAmount
        totalGame
        totalQuantity
        totalTransactions
        transactionHash
      }
      orders {
        projectId
        qty
        tokenId
        transactionHash
        id
        idGame
        maker {
          address
          id
          totalQuantity
          totalReward
          totalTransactions
          totalVolume
        }
        amount
        blockNumber
        blockTimestamp
        contractGame
        orderDetail {
          id
          totalReward
          win
        }
      }
    }
  }
`

/**
 * __useGetCreateGameQuery__
 *
 * To run a query within a React component, call `useGetCreateGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateGameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreateGameQuery(
  baseOptions: Apollo.QueryHookOptions<GetCreateGameQuery, GetCreateGameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCreateGameQuery, GetCreateGameQueryVariables>(GetCreateGameDocument, options)
}
export function useGetCreateGameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreateGameQuery, GetCreateGameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCreateGameQuery, GetCreateGameQueryVariables>(GetCreateGameDocument, options)
}
export function useGetCreateGameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreateGameQuery, GetCreateGameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCreateGameQuery, GetCreateGameQueryVariables>(GetCreateGameDocument, options)
}
export type GetCreateGameQueryHookResult = ReturnType<typeof useGetCreateGameQuery>
export type GetCreateGameLazyQueryHookResult = ReturnType<typeof useGetCreateGameLazyQuery>
export type GetCreateGameSuspenseQueryHookResult = ReturnType<typeof useGetCreateGameSuspenseQuery>
export type GetCreateGameQueryResult = Apollo.QueryResult<GetCreateGameQuery, GetCreateGameQueryVariables>
export const GetOrderRewardDocument = gql`
  query getOrderReward($idGame: BigInt, $gameContract: Bytes) {
    orderRewards(where: { idGame: $idGame, gameContract: $gameContract }) {
      values
      transactionHash
      idGame
      id
      gameContract
      quantity
      tokenId
    }
  }
`

/**
 * __useGetOrderRewardQuery__
 *
 * To run a query within a React component, call `useGetOrderRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderRewardQuery({
 *   variables: {
 *      idGame: // value for 'idGame'
 *      gameContract: // value for 'gameContract'
 *   },
 * });
 */
export function useGetOrderRewardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrderRewardQuery, GetOrderRewardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrderRewardQuery, GetOrderRewardQueryVariables>(GetOrderRewardDocument, options)
}
export function useGetOrderRewardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrderRewardQuery, GetOrderRewardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrderRewardQuery, GetOrderRewardQueryVariables>(GetOrderRewardDocument, options)
}
export function useGetOrderRewardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderRewardQuery, GetOrderRewardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOrderRewardQuery, GetOrderRewardQueryVariables>(GetOrderRewardDocument, options)
}
export type GetOrderRewardQueryHookResult = ReturnType<typeof useGetOrderRewardQuery>
export type GetOrderRewardLazyQueryHookResult = ReturnType<typeof useGetOrderRewardLazyQuery>
export type GetOrderRewardSuspenseQueryHookResult = ReturnType<typeof useGetOrderRewardSuspenseQuery>
export type GetOrderRewardQueryResult = Apollo.QueryResult<GetOrderRewardQuery, GetOrderRewardQueryVariables>
export const GetPopularSpinDocument = gql`
  query getPopularSpin($first: Int, $title: String) {
    createGames(skip: 1, first: $first, orderBy: totalQuantity, where: { title_contains: $title }) {
      id
      title
      values
      totalTransactions
      totalQuantity
      totalPayAmount
      startPrice
      price
      percents
      ownerPercent
      newGameContract
      jackpotValue
      jackpotTerm
      jackpotPercent
      idGame
      affiliatePercent
      megaGameContract {
        affFee
        blockNumber
        blockTimestamp
        contractGameNew
        contractGameOrigin
        contractToken
        deployedFee
        id
        devFee
        name
        mktFee
        projectId
        ownerFee
        totalGame
        totalPayAmount
        totalQuantity
        totalTransactions
        transactionHash
        token {
          id
          name
          decimals
          symbol
        }
      }
      ownerFee
      orders {
        id
        idGame
        blockNumber
        blockTimestamp
        contractGame
        qty
        projectId
        tokenId
      }
    }
  }
`

/**
 * __useGetPopularSpinQuery__
 *
 * To run a query within a React component, call `useGetPopularSpinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularSpinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularSpinQuery({
 *   variables: {
 *      first: // value for 'first'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetPopularSpinQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPopularSpinQuery, GetPopularSpinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPopularSpinQuery, GetPopularSpinQueryVariables>(GetPopularSpinDocument, options)
}
export function useGetPopularSpinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPopularSpinQuery, GetPopularSpinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPopularSpinQuery, GetPopularSpinQueryVariables>(GetPopularSpinDocument, options)
}
export function useGetPopularSpinSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPopularSpinQuery, GetPopularSpinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPopularSpinQuery, GetPopularSpinQueryVariables>(GetPopularSpinDocument, options)
}
export type GetPopularSpinQueryHookResult = ReturnType<typeof useGetPopularSpinQuery>
export type GetPopularSpinLazyQueryHookResult = ReturnType<typeof useGetPopularSpinLazyQuery>
export type GetPopularSpinSuspenseQueryHookResult = ReturnType<typeof useGetPopularSpinSuspenseQuery>
export type GetPopularSpinQueryResult = Apollo.QueryResult<GetPopularSpinQuery, GetPopularSpinQueryVariables>
export const GetProjectJackpotsDocument = gql`
  query getProjectJackpots($megaGameContract: String, $skip: Int, $first: Int, $title: String) {
    createGames(
      where: { megaGameContract: $megaGameContract, title_contains_nocase: $title }
      first: $first
      skip: $skip
    ) {
      idGame
      jackpotTerm
      jackpotPercent
      jackpotValue
      newGameContract
      ownerFee
      ownerPercent
      percents
      price
      startPrice
      title
      totalPayAmount
      totalQuantity
      totalTransactions
      values
      id
      blockNumber
      blockTimestamp
      orders {
        amount
        blockNumber
        blockTimestamp
        contractGame
        id
        idGame
        projectId
        qty
        tokenId
        transactionHash
        maker {
          address
          id
          totalVolume
          totalTransactions
          totalReward
          totalQuantity
        }
      }
    }
  }
`

/**
 * __useGetProjectJackpotsQuery__
 *
 * To run a query within a React component, call `useGetProjectJackpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectJackpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectJackpotsQuery({
 *   variables: {
 *      megaGameContract: // value for 'megaGameContract'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetProjectJackpotsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>(GetProjectJackpotsDocument, options)
}
export function useGetProjectJackpotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>(
    GetProjectJackpotsDocument,
    options,
  )
}
export function useGetProjectJackpotsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProjectJackpotsQuery, GetProjectJackpotsQueryVariables>(
    GetProjectJackpotsDocument,
    options,
  )
}
export type GetProjectJackpotsQueryHookResult = ReturnType<typeof useGetProjectJackpotsQuery>
export type GetProjectJackpotsLazyQueryHookResult = ReturnType<typeof useGetProjectJackpotsLazyQuery>
export type GetProjectJackpotsSuspenseQueryHookResult = ReturnType<typeof useGetProjectJackpotsSuspenseQuery>
export type GetProjectJackpotsQueryResult = Apollo.QueryResult<
  GetProjectJackpotsQuery,
  GetProjectJackpotsQueryVariables
>
export const GetTotalParticipantsDocument = gql`
  query getTotalParticipants {
    orders {
      qty
    }
  }
`

/**
 * __useGetTotalParticipantsQuery__
 *
 * To run a query within a React component, call `useGetTotalParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalParticipantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalParticipantsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>(
    GetTotalParticipantsDocument,
    options,
  )
}
export function useGetTotalParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>(
    GetTotalParticipantsDocument,
    options,
  )
}
export function useGetTotalParticipantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTotalParticipantsQuery, GetTotalParticipantsQueryVariables>(
    GetTotalParticipantsDocument,
    options,
  )
}
export type GetTotalParticipantsQueryHookResult = ReturnType<typeof useGetTotalParticipantsQuery>
export type GetTotalParticipantsLazyQueryHookResult = ReturnType<typeof useGetTotalParticipantsLazyQuery>
export type GetTotalParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetTotalParticipantsSuspenseQuery>
export type GetTotalParticipantsQueryResult = Apollo.QueryResult<
  GetTotalParticipantsQuery,
  GetTotalParticipantsQueryVariables
>
export const GetProjectParticipantDocument = gql`
  query getProjectParticipant($projectId: String) {
    orders(where: { projectId: $projectId }) {
      qty
    }
  }
`

/**
 * __useGetProjectParticipantQuery__
 *
 * To run a query within a React component, call `useGetProjectParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectParticipantQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectParticipantQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>(
    GetProjectParticipantDocument,
    options,
  )
}
export function useGetProjectParticipantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>(
    GetProjectParticipantDocument,
    options,
  )
}
export function useGetProjectParticipantSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProjectParticipantQuery, GetProjectParticipantQueryVariables>(
    GetProjectParticipantDocument,
    options,
  )
}
export type GetProjectParticipantQueryHookResult = ReturnType<typeof useGetProjectParticipantQuery>
export type GetProjectParticipantLazyQueryHookResult = ReturnType<typeof useGetProjectParticipantLazyQuery>
export type GetProjectParticipantSuspenseQueryHookResult = ReturnType<typeof useGetProjectParticipantSuspenseQuery>
export type GetProjectParticipantQueryResult = Apollo.QueryResult<
  GetProjectParticipantQuery,
  GetProjectParticipantQueryVariables
>
export const GetProjectStatisticDocument = gql`
  query getProjectStatistic($projectId: String) {
    orders(where: { projectId: $projectId }, orderBy: blockTimestamp) {
      amount
      blockTimestamp
      blockNumber
      qty
      id
    }
  }
`

/**
 * __useGetProjectStatisticQuery__
 *
 * To run a query within a React component, call `useGetProjectStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatisticQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectStatisticQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>(
    GetProjectStatisticDocument,
    options,
  )
}
export function useGetProjectStatisticLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>(
    GetProjectStatisticDocument,
    options,
  )
}
export function useGetProjectStatisticSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProjectStatisticQuery, GetProjectStatisticQueryVariables>(
    GetProjectStatisticDocument,
    options,
  )
}
export type GetProjectStatisticQueryHookResult = ReturnType<typeof useGetProjectStatisticQuery>
export type GetProjectStatisticLazyQueryHookResult = ReturnType<typeof useGetProjectStatisticLazyQuery>
export type GetProjectStatisticSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatisticSuspenseQuery>
export type GetProjectStatisticQueryResult = Apollo.QueryResult<
  GetProjectStatisticQuery,
  GetProjectStatisticQueryVariables
>
export const GetSpinResultsDocument = gql`
  query GetSpinResults($id: ID!) {
    orderDetail(id: $id) {
      win
      totalReward
      ownerFee
      idGame
      affFee
      devFee
      mktFee
      id
      orderRewards {
        values
        quantity
        idGame
        id
        tokenId
        gameContract
        transactionHash
        orderDetail {
          win
          devFee
          affFee
          orderRewards {
            values
          }
        }
      }
    }
  }
`

/**
 * __useGetSpinResultsQuery__
 *
 * To run a query within a React component, call `useGetSpinResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpinResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpinResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpinResultsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSpinResultsQuery, GetSpinResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSpinResultsQuery, GetSpinResultsQueryVariables>(GetSpinResultsDocument, options)
}
export function useGetSpinResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSpinResultsQuery, GetSpinResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSpinResultsQuery, GetSpinResultsQueryVariables>(GetSpinResultsDocument, options)
}
export function useGetSpinResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpinResultsQuery, GetSpinResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSpinResultsQuery, GetSpinResultsQueryVariables>(GetSpinResultsDocument, options)
}
export type GetSpinResultsQueryHookResult = ReturnType<typeof useGetSpinResultsQuery>
export type GetSpinResultsLazyQueryHookResult = ReturnType<typeof useGetSpinResultsLazyQuery>
export type GetSpinResultsSuspenseQueryHookResult = ReturnType<typeof useGetSpinResultsSuspenseQuery>
export type GetSpinResultsQueryResult = Apollo.QueryResult<GetSpinResultsQuery, GetSpinResultsQueryVariables>
